import React, { useState, useEffect } from "react";
import axios from "axios";
import "./CabSearchModify.css";
import { Spinner } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const CabSearchModify = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Ride type
  const [rideType, setRideType] = useState("airport");
  const [transferType, setTransferType] = useState("Airport PickUp");

  // Input states
  const [searchInput, setSearchInput] = useState(""); // Transfer/Hourly pickup
  const [searchInput2, setSearchInput2] = useState(""); // Transfer drop
  const [outSearch, setOutSearch] = useState(""); // Outstation pickup
  const [outSearch2, setOutSearch2] = useState(""); // Outstation drop
  const [localSearch, setLocalSearch] = useState(""); // Local pickup

  // Autocomplete
  const [cities2, setCities2] = useState([]);
  const [cities22, setCities22] = useState([]);
  const [clickDestination, SetClickDestination] = useState(false);
  const [clickDestination2, SetClickDestination2] = useState(false);
  const [isItemSelected, setIsItemSelected] = useState(false);
  const [isItemSelected2, setIsItemSelected2] = useState(false);

  // Hourly autocomplete
  const [hourlyCities, setHourlyCities] = useState([]);
  const [clickHourly, setClickHourly] = useState(false);
  const [isHourlySelected, setIsHourlySelected] = useState(false);

  // Date/time
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedHours, setSelectedHours] = useState("2");

  // Transfer
const [transferDateTime, setTransferDateTime] = useState(null);

// Outstation
const [outstationStartDateTime, setOutstationStartDateTime] = useState(null);
const [outstationEndDateTime, setOutstationEndDateTime] = useState(null);

// Hourly
const [hourlyDateTime, setHourlyDateTime] = useState(null);


useEffect(() => {
  const params = new URLSearchParams(location.search);
  const tripType = params.get("tripType");

  if (tripType === "transfer") {
    setRideType("airport");
    setTransferType(params.get("transferType") || "Airport PickUp");
    setSearchInput(params.get("pickup") || "");
    setSearchInput2(params.get("drop") || "");

    const startDateParam = params.get("startDate");
    const startTimeParam = params.get("startTime");
    if (startDateParam && startTimeParam) {
      setTransferDateTime(`${startDateParam}T${startTimeParam}`);
    }
  } else if (tripType === "outstation") {
    setRideType("outstation");
    setOutSearch(params.get("pickup") || "");
    setOutSearch2(params.get("drop") || "");

    const startDateParam = params.get("startDate");
    const startTimeParam = params.get("startTime");
    const endDateParam = params.get("endDate");
    const endTimeParam = params.get("endTime");

    if (startDateParam && startTimeParam) {
      setOutstationStartDateTime(`${startDateParam}T${startTimeParam}`);
    }
    if (endDateParam && endTimeParam) {
      setOutstationEndDateTime(`${endDateParam}T${endTimeParam}`);
    }
  } else if (tripType === "local") {
    setRideType("hourly");
    setLocalSearch(params.get("pickup") || "");
    setSelectedHours(params.get("durationHours") || "2");

    const startDateParam = params.get("startDate");
    const startTimeParam = params.get("startTime");
    if (startDateParam && startTimeParam) {
      setHourlyDateTime(`${startDateParam}T${startTimeParam}`);
    }
  }
}, [location.search]);


  // Fetch autocomplete data
  const fetchCities = (value, setter) => {
    axios
      .post("https://admin.travelsdata.com/api/Cab/City", { city: value })
      .then((response) => {
        const results = response.data.data.filter(
          (item) =>
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.address.toLowerCase().includes(value.toLowerCase())
        );
        setter(results);
      })
      .catch((err) => console.error(err));
  };

  const handleInputChange = (value) => {
    if (rideType === "airport") setSearchInput(value);
    else if (rideType === "outstation") setOutSearch(value);
    else if (rideType === "hourly") setLocalSearch(value);

    if (rideType === "hourly") {
      setClickHourly(true);
      setIsHourlySelected(false);
    } else {
      SetClickDestination(true);
      setIsItemSelected(false);
    }

    if (value.length >= 3) {
      if (rideType === "hourly") fetchCities(value, setHourlyCities);
      else fetchCities(value, setCities2);
    } else {
      if (rideType === "hourly") setHourlyCities([]);
      else setCities2([]);
    }
  };

  const handleInputChange2 = (value) => {
    if (rideType === "airport") setSearchInput2(value);
    if (rideType === "outstation") setOutSearch2(value);

    SetClickDestination2(true);
    setIsItemSelected2(false);

    if (value.length >= 3) fetchCities(value, setCities22);
    else setCities22([]);
  };

  const handleSourceSelect = (city) => {
    if (rideType === "outstation") setOutSearch(city.name);
    else setSearchInput(city.name);

    setIsItemSelected(true);
    SetClickDestination(false);
  };

  const handleCitySelect2 = (city) => {
    if (rideType === "outstation") setOutSearch2(city.name);
    else setSearchInput2(city.name);

    setIsItemSelected2(true);
    SetClickDestination2(false);
  };

const handleSearch = () => {
  let queryParams = {};

  const getDateTimeParts = (dateTime) => {
    if (!dateTime) return { date: "", time: "" };
    const [date, time] = dateTime.split("T");
    return { date, time };
  };

  if (rideType === "airport") {
    const { date, time } = getDateTimeParts(transferDateTime);

    if (!date || !time) {
      alert("Please select pickup date & time");
      return;
    }

    queryParams = {
      tripType: "transfer",
      transferType,
      pickup: searchInput,
      drop: searchInput2,
      startDate: date,
      startTime: time,
    };
  }

  else if (rideType === "outstation") {
    const { date: startDate, time: startTime } =
      getDateTimeParts(outstationStartDateTime);
    const { date: endDate, time: endTime } =
      getDateTimeParts(outstationEndDateTime);

    if (!startDate || !startTime) {
      alert("Please select start date & time");
      return;
    }

    queryParams = {
      tripType: "outstation",
      pickup: outSearch,
      drop: outSearch2,
      startDate,
      startTime,
      endDate,
      endTime,
    };
  }

  else if (rideType === "hourly") {
    const { date, time } = getDateTimeParts(hourlyDateTime);

    if (!date || !time) {
      alert("Please select date & time");
      return;
    }

    queryParams = {
      tripType: "local",
      pickup: localSearch,
      drop: localSearch,
      startDate: date,
      startTime: time,
      durationHours: selectedHours,
    };
  }

  const queryString = new URLSearchParams(queryParams).toString();
  navigate(`/cablisting?${queryString}`);
};


  return (
    <div className="cabSearchModify-Main">
      <div className="cabSearchModify-top">
        <div className="cabSearchModify-radioGroup">
          <label>
            <input
              type="radio"
              name="rideType"
              value="airport"
              checked={rideType === "airport"}
              onChange={() => setRideType("airport")}
            />
            <span>AIRPORT TRANSFER</span>
          </label>

          <label>
            <input
              type="radio"
              name="rideType"
              value="outstation"
              checked={rideType === "outstation"}
              onChange={() => setRideType("outstation")}
            />
            <span>OUTSTATION/OTHER</span>
          </label>

          <label>
            <input
              type="radio"
              name="rideType"
              value="hourly"
              checked={rideType === "hourly"}
              onChange={() => setRideType("hourly")}
            />
            <span>HOURLY</span>
          </label>
        </div>
      </div>

      {/* AIRPORT TRANSFER FORM */}
      {rideType === "airport" && (
        <div className="cabSearchModify-form">
          <select
            className="cabSearchModify-selectOptions"
            value={transferType}
            onChange={(e) => setTransferType(e.target.value)}
          >
            <option>Airport PickUp</option>
            <option>Airport Drop</option>
          </select>

          {/* Pickup Input */}
          <div style={{ position: "relative", marginBottom: "10px" }}>
            <input
              type="text"
              className="cabSearchModify-inputWhite wide"
              placeholder="Enter pickup location"
              value={searchInput}
              onChange={(e) => handleInputChange(e.target.value)}
              onFocus={() => SetClickDestination(true)}
            />
            {clickDestination && (
              <div
                className="cityselect"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  width: "100%",
                  backgroundColor: "white",
                  border: "1px solid #cdcdcd",
                  maxHeight: 200,
                  overflowY: "auto",
                  zIndex: 9999,
                }}
              >
                {cities2.length > 0 ? (
                  cities2.map((city, index) => (
                    <div
                      key={index}
                      className="react-autosuggest__suggestion"
                      onClick={() => handleSourceSelect(city)}
                    >
                      <div className="makeFlex">
                        <img
                          src="/Images/cabicons.png"
                          className="icLocAltCab"
                        />
                        <div className="makeFlex flexOne column">
                          <p className="font_search_bookingss">{city.name}</p>
                          <p className="lightGreyText font12">{city.address}</p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  searchInput.length >= 2 && (
                    <div
                      style={{
                        padding: "10px",
                        fontSize: "12px",
                        textAlign: "center",
                      }}
                    >
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      Please wait, we are fetching city list...
                    </div>
                  )
                )}
              </div>
            )}
          </div>

          {/* Drop Input */}
          <div style={{ position: "relative", marginBottom: "10px" }}>
            <input
              type="text"
              className="cabSearchModify-inputWhite wide"
              placeholder="Enter drop location"
              value={searchInput2}
              onChange={(e) => handleInputChange2(e.target.value)}
              onFocus={() => SetClickDestination2(true)}
            />
            {clickDestination2 && (
              <div
                className="cityselect"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  width: "100%",
                  backgroundColor: "white",
                  border: "1px solid #cdcdcd",
                  maxHeight: 200,
                  overflowY: "auto",
                  zIndex: 9999,
                }}
              >
                {cities22.length > 0 ? (
                  cities22.map((city, index) => (
                    <div
                      key={index}
                      className="react-autosuggest__suggestion"
                      onClick={() => handleCitySelect2(city)}
                    >
                      <div className="makeFlex">
                        <img
                          src="/Images/cabicons.png"
                          className="icLocAltCab"
                        />
                        <div className="makeFlex flexOne column">
                          <p className="font_search_bookingss">{city.name}</p>
                          <p className="lightGreyText font12">{city.address}</p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  searchInput2.length >= 2 && (
                    <div
                      style={{
                        padding: "10px",
                        fontSize: "12px",
                        textAlign: "center",
                      }}
                    >
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      Please wait, we are fetching city list...
                    </div>
                  )
                )}
              </div>
            )}
          </div>

          <input
            type="datetime-local"
            className="cabSearchModify-inputWhiteDateTime"
            value={transferDateTime || ""}
            onChange={(e) => setTransferDateTime(e.target.value)}
          />

          <button className="cabSearchModify-btn" onClick={handleSearch}>
            SEARCH
          </button>
        </div>
      )}

      {/* OUTSTATION FORM */}
      {rideType === "outstation" && (
        <div className="cabSearchModify-form">
          <div style={{ position: "relative", marginBottom: "10px" }}>
            <input
              type="text"
              className="cabSearchModify-inputWhite wideOutstation"
              placeholder="Enter source location"
              value={outSearch}
              onChange={(e) => handleInputChange(e.target.value)}
              onFocus={() => SetClickDestination(true)}
            />
            {clickDestination && cities2.length > 0 && (
              <div
                className="cityselect"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  width: "100%",
                  backgroundColor: "white",
                  border: "1px solid #cdcdcd",
                  maxHeight: 200,
                  overflowY: "auto",
                  zIndex: 9999,
                }}
              >
                {cities2.map((city, index) => (
                  <div
                    key={index}
                    onClick={() => handleSourceSelect(city)}
                    className="react-autosuggest__suggestion"
                  >
                    {city.name} ({city.address})
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{ position: "relative", marginBottom: "10px" }}>
            <input
              type="text"
              className="cabSearchModify-inputWhite wideOutstation"
              placeholder="Enter destination location"
              value={outSearch2}
              onChange={(e) => handleInputChange2(e.target.value)}
              onFocus={() => SetClickDestination2(true)}
            />
            {clickDestination2 && cities22.length > 0 && (
              <div
                className="cityselect"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  width: "100%",
                  backgroundColor: "white",
                  border: "1px solid #cdcdcd",
                  maxHeight: 200,
                  overflowY: "auto",
                  zIndex: 9999,
                }}
              >
                {cities22.map((city, index) => (
                  <div
                    key={index}
                    onClick={() => handleCitySelect2(city)}
                    className="react-autosuggest__suggestion"
                  >
                    {city.name} ({city.address})
                  </div>
                ))}
              </div>
            )}
          </div>

          <input
            type="datetime-local"
            className="cabSearchModify-inputWhiteDateTimeOutstation"
            value={outstationEndDateTime  || ""}
            onChange={(e) => setOutstationEndDateTime(e.target.value)}
          />
          <input
            type="datetime-local"
            className="cabSearchModify-inputWhiteDateTimeOutstation"
            value={endDate || ""}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <button className="cabSearchModify-btn" onClick={handleSearch}>
            SEARCH
          </button>
        </div>
      )}

      {/* HOURLY FORM */}
      {rideType === "hourly" && (
        <div className="cabSearchModify-form">
          <div style={{ position: "relative", marginBottom: "10px" }}>
            <input
              type="text"
              className="cabSearchModify-inputWhite wideHourly"
              placeholder="Enter location"
              value={localSearch}
              onChange={(e) => handleInputChange(e.target.value)}
              onFocus={() => setClickHourly(true)}
            />
            {clickHourly && hourlyCities.length > 0 && (
              <div
                className="cityselect"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  width: "100%",
                  backgroundColor: "white",
                  border: "1px solid #cdcdcd",
                  maxHeight: 200,
                  overflowY: "auto",
                  zIndex: 9999,
                }}
              >
                {hourlyCities.map((city, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setLocalSearch(city.name);
                      setIsHourlySelected(true);
                      setClickHourly(false);
                    }}
                    className="react-autosuggest__suggestion"
                  >
                    {city.name} ({city.address})
                  </div>
                ))}
              </div>
            )}
          </div>

          <input
            type="datetime-local"
            className="cabSearchModify-inputWhiteDateTime"
            value={hourlyDateTime || ""}
            onChange={(e) => setHourlyDateTime(e.target.value)}
          />

          <select
            className="cabSearchModify-selectOptions"
            value={selectedHours}
            onChange={(e) => setSelectedHours(e.target.value)}
          >
            <option value="2">02 HRs.</option>
            <option value="4">04 HRs.</option>
            <option value="6">06 HRs.</option>
            <option value="12">12 HRs.</option>
          </select>

          <button className="cabSearchModify-btn" onClick={handleSearch}>
            SEARCH
          </button>
        </div>
      )}
    </div>
  );
};

export default CabSearchModify;
